// extracted by mini-css-extract-plugin
export default {"CenteredResult":"SearchResults_CenteredResult__wGOxu"};